export interface Comic {
  id: string;
  title: string;
  cover: string;
  category: string;
  status: "连载中" | "已完结" | "番外更新中";
  chapters: string;
  latest: string;
  views: string;
  rating: number;
  tags: string[];
  description: string;
}

export const comics: Comic[] = [
  {
    id: "1",
    title: "焚天剑尊",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20manga%20cover%20art%20of%20a%20young%20swordsman%20wielding%20a%20flaming%20sword%20in%20a%20dark%20fantasy%20world%2C%20crimson%20flames%20swirling%20around%20the%20blade%2C%20dramatic%20red%20and%20black%20color%20palette%2C%20ink%20brush%20style%20anime%20illustration%2C%20high%20contrast%20rim%20lighting%2C%20epic%20battle%20atmosphere%2C%20detailed%20character%20design%20with%20flowing%20robe%20and%20determined%20expression%2C%20professional%20digital%20comic%20cover%20artwork%20with%20bold%20composition%20and%20cinematic%20lighting&width=480&height=680&seq=cover-mh-01&orientation=portrait",
    category: "热血玄幻",
    status: "连载中",
    chapters: "第 428 话",
    latest: "3 小时前更新",
    views: "2.31 亿",
    rating: 9.6,
    tags: ["热血", "玄幻", "重生"],
    description: "三年前，天才剑修叶无双遭宗门背弃、修为尽废。三年后，他携上古焚天神剑归来，一剑荡平昔日仇敌，从此踏上问鼎诸天的剑道之路。",
  },
  {
    id: "2",
    title: "都市超级神豪",
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20manga%20cover%20featuring%20a%20confident%20young%20businessman%20in%20a%20sharp%20suit%20standing%20before%20a%20glittering%20city%20skyline%20at%20dusk%2C%20gold%20and%20warm%20amber%20tones%20with%20red%20accents%2C%20sleek%20commercial%20illustration%20style%2C%20cinematic%20depth%20of%20field%2C%20luxury%20and%20success%20atmosphere%2C%20professional%20anime%20cover%20art%20with%20clean%20linework%20and%20vibrant%20color%20grading%20for%20a%20city%20life%20comic&width=480&height=680&seq=cover-mh-02&orientation=portrait",
    category: "都市职场",
    status: "连载中",
    chapters: "第 316 话",
    latest: "5 小时前更新",
    views: "1.87 亿",
    rating: 9.1,
    tags: ["都市", "逆袭", "神豪"],
    description: "普通职员林辰意外绑定神豪系统，从此豪车、豪宅、上市公司接踵而来，他用智慧与实力在商海掀起惊涛骇浪，成就一代都市传奇。",
  },
  {
    id: "3",
    title: "心动警报·同桌的你",
    cover: "https://readdy.ai/api/search-image?query=Cute%20high%20school%20romance%20manga%20cover%20with%20two%20students%20sitting%20side%20by%20side%20at%20a%20classroom%20desk%2C%20soft%20pastel%20pink%20and%20cream%20colors%20with%20warm%20golden%20light%2C%20gentle%20blushing%20expressions%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20dreamy%20anime%20illustration%20style%2C%20sweet%20and%20tender%20atmosphere%2C%20clean%20vector-like%20linework%2C%20adorable%20chibi%20touches%2C%20vibrant%20romantic%20school%20life%20comic%20cover%20art&width=480&height=680&seq=cover-mh-03&orientation=portrait",
    category: "恋爱校园",
    status: "连载中",
    chapters: "第 152 话",
    latest: "2 小时前更新",
    views: "1.42 亿",
    rating: 9.3,
    tags: ["校园", "恋爱", "甜宠"],
    description: "转学生苏晴晴一进门就撞上了年级第一的冰山学霸。从针锋相对到悄悄心动，那段同桌的时光里，藏着整个青春最甜的暗恋。",
  },
  {
    id: "4",
    title: "深夜侦探事务所",
    cover: "https://readdy.ai/api/search-image?query=Mystery%20detective%20manga%20cover%20with%20a%20trench-coat%20detective%20silhouette%20under%20a%20single%20street%20lamp%20in%20the%20foggy%20night%2C%20dark%20navy%20and%20deep%20teal%20tones%20with%20a%20glowing%20amber%20lamp%2C%20magnifying%20glass%20and%20scattered%20case%20files%2C%20noir%20suspense%20atmosphere%2C%20dramatic%20shadow%20play%2C%20anime%20illustration%20with%20strong%20moody%20lighting%20and%20detailed%20urban%20night%20background%2C%20gripping%20crime%20thriller%20comic%20cover%20art&width=480&height=680&seq=cover-mh-04&orientation=portrait",
    category: "悬疑推理",
    status: "已完结",
    chapters: "全 96 话",
    latest: "已完结",
    views: "9860 万",
    rating: 9.4,
    tags: ["推理", "悬疑", "案件"],
    description: "只在深夜营业的侦探事务所，接手的都是白天无人敢碰的奇案。每个案件背后，都藏着一个不为人知的秘密，等着被一一点破。",
  },
  {
    id: "5",
    title: "星海远征军",
    cover: "https://readdy.ai/api/search-image?query=Epic%20space%20opera%20manga%20cover%20of%20an%20astronaut%20pilot%20in%20a%20sleek%20mecha%20suit%20facing%20a%20swirling%20galaxy%20nebula%2C%20purple%20and%20teal%20cosmic%20colors%20with%20red%20ship%20lights%2C%20vast%20starfield%20and%20distant%20planets%2C%20sense%20of%20scale%20and%20wonder%2C%20cinematic%20sci-fi%20anime%20illustration%2C%20dramatic%20backlighting%2C%20high%20detail%20mechanical%20design%2C%20adventurous%20interstellar%20exploration%20comic%20cover%20art&width=480&height=680&seq=cover-mh-05&orientation=portrait",
    category: "科幻冒险",
    status: "连载中",
    chapters: "第 268 话",
    latest: "昨天更新",
    views: "1.13 亿",
    rating: 9.2,
    tags: ["科幻", "星际", "机甲"],
    description: "人类把目光投向星辰大海。一支年轻的远征军驾驶机甲深入未知星域，寻找可居住的殖民星，也揭开宇宙深处的终极秘密。",
  },
  {
    id: "6",
    title: "咸鱼躺平日常",
    cover: "https://readdy.ai/api/search-image?query=Humorous%20slice%20of%20life%20manga%20cover%20with%20a%20happy%20lazy%20young%20man%20lounging%20on%20a%20giant%20sofa%20surrounded%20by%20snacks%20and%20game%20consoles%2C%20warm%20bright%20colors%20with%20red%20and%20gold%20accents%2C%20exaggerated%20funny%20expressions%2C%20funny%20cartoon%20anime%20style%2C%20light-hearted%20playful%20mood%2C%20bubble%20speech%20marks%2C%20clean%20bold%20linework%2C%20cheerful%20everyday%20comedy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-06&orientation=portrait",
    category: "搞笑日常",
    status: "连载中",
    chapters: "第 204 话",
    latest: "4 小时前更新",
    views: "1.25 亿",
    rating: 9.0,
    tags: ["搞笑", "日常", "轻松"],
    description: "立志当一条快乐咸鱼的社畜阿呆，每天都在和「想躺平」作斗争。笑点密集的爆笑日常，帮你把不开心的全部赶跑。",
  },
  {
    id: "7",
    title: "御剑问长生",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20xianxia%20manga%20cover%20with%20a%20robed%20cultivator%20flying%20on%20a%20glowing%20jade%20sword%20through%20misty%20mountains%20at%20sunrise%2C%20ink%20wash%20painting%20style%20combined%20with%20anime%2C%20elegant%20teal%20and%20gold%20palette%20with%20red%20accents%2C%20drifting%20clouds%20and%20ancient%20pagodas%20below%2C%20ethereal%20immortal%20atmosphere%2C%20flowing%20fabric%20and%20hair%2C%20refined%20brushwork%2C%20breathtaking%20fantasy%20wuxia%20comic%20cover%20art&width=480&height=680&seq=cover-mh-07&orientation=portrait",
    category: "武侠仙侠",
    status: "连载中",
    chapters: "第 352 话",
    latest: "6 小时前更新",
    views: "1.56 亿",
    rating: 9.5,
    tags: ["仙侠", "修真", "飞升"],
    description: "一介凡人少年偶得上古剑诀，从山村走向九霄。御剑问长生，斩尽天下不平，他要在仙途尽头，走出属于自己的大道。",
  },
  {
    id: "8",
    title: "猫咪便利店",
    cover: "https://readdy.ai/api/search-image?query=Heartwarming%20manga%20cover%20of%20a%20fluffy%20white%20cat%20working%20as%20a%20little%20shopkeeper%20at%20a%20cozy%20neighborhood%20convenience%20store%2C%20warm%20cream%20and%20honey%20tones%20with%20soft%20red%20accents%2C%20shelves%20full%20of%20cute%20snacks%2C%20gentle%20evening%20sunlight%20through%20the%20window%2C%20calm%20healing%20atmosphere%2C%20adorable%20kawaii%20anime%20illustration%20style%2C%20soft%20rounded%20shapes%20and%20warm%20lighting%2C%20wholesome%20cozy%20comfort%20comic%20cover%20art&width=480&height=680&seq=cover-mh-08&orientation=portrait",
    category: "治愈温馨",
    status: "已完结",
    chapters: "全 78 话",
    latest: "已完结",
    views: "8230 万",
    rating: 9.4,
    tags: ["治愈", "温馨", "日常"],
    description: "街角那家深夜便利店，老板其实是一只温柔的白猫。每一个失眠的夜，它都会用暖暖的热茶和软软的话，接住你的疲惫。",
  },
  {
    id: "9",
    title: "万古圣主",
    cover: "https://readdy.ai/api/search-image?query=Grand%20fantasy%20manga%20cover%20of%20an%20ancient%20emperor%20figure%20crowned%20and%20seated%20on%20a%20golden%20throne%20with%20radiant%20divine%20light%2C%20majestic%20crimson%20and%20gold%20color%20scheme%2C%20floating%20runes%20and%20celestial%20energy%2C%20epic%20scale%20and%20regal%20presence%2C%20powerful%20anime%20illustration%20style%2C%20ornate%20armor%20and%20flowing%20cape%2C%20dramatic%20lighting%20and%20aura%2C%20awe%20inspiring%20cultivation%20fantasy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-09&orientation=portrait",
    category: "热血玄幻",
    status: "连载中",
    chapters: "第 512 话",
    latest: "1 小时前更新",
    views: "2.68 亿",
    rating: 9.7,
    tags: ["玄幻", "热血", "争霸"],
    description: "沉睡万古的圣主苏醒，天地早已换了人间。他重铸圣体、再临巅峰，一句「我回来了」，便是诸天万界新的浩劫与希望。",
  },
  {
    id: "10",
    title: "顶流经纪人",
    cover: "https://readdy.ai/api/search-image?query=Showbiz%20drama%20manga%20cover%20with%20a%20stylish%20female%20talent%20agent%20holding%20a%20clipboard%20backstage%20at%20a%20glamorous%20concert%2C%20spotlights%20and%20confetti%20in%20gold%20and%20crimson%20tones%2C%20confident%20poised%20expression%2C%20entertainment%20industry%20atmosphere%2C%20dynamic%20anime%20illustration%2C%20warm%20stage%20lighting%20with%20red%20curtains%2C%20energetic%20and%20fashionable%2C%20compelling%20show%20business%20comic%20cover%20art&width=480&height=680&seq=cover-mh-10&orientation=portrait",
    category: "都市职场",
    status: "连载中",
    chapters: "第 189 话",
    latest: "昨天更新",
    views: "8970 万",
    rating: 9.0,
    tags: ["娱乐圈", "逆袭", "爽文"],
    description: "从被雪藏的小助理到只手捧出顶流的金牌经纪人，她用头脑和手腕改写规则，把不可能变成热搜，把新人送上巅峰。",
  },
  {
    id: "11",
    title: "同桌是只小狐狸",
    cover: "https://readdy.ai/api/search-image?query=Sweet%20fantasy%20school%20romance%20manga%20cover%20of%20a%20cute%20fox-eared%20girl%20student%20with%20a%20mischievous%20smile%20sitting%20at%20a%20desk%20in%20a%20sunny%20classroom%2C%20soft%20pink%20and%20cream%20colors%20with%20warm%20amber%20light%2C%20floating%20sparkles%20and%20tiny%20fox%20tails%2C%20adorable%20anime%20illustration%2C%20gentle%20blush%20and%20playful%20expression%2C%20dreamy%20soft-focus%20background%2C%20enchanting%20charming%20school%20fantasy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-11&orientation=portrait",
    category: "恋爱校园",
    status: "连载中",
    chapters: "第 168 话",
    latest: "3 小时前更新",
    views: "1.31 亿",
    rating: 9.2,
    tags: ["恋爱", "奇幻", "校园"],
    description: "转学来的新同桌，竟是一只修炼千年的小狐狸精！她赖上你蹭妖气，顺便把一场跨越种族的恋爱，谈得甜到掉牙。",
  },
  {
    id: "12",
    title: "记忆迷城",
    cover: "https://readdy.ai/api/search-image?query=Psychological%20thriller%20manga%20cover%20with%20a%20cracked%20mirror%20reflecting%20a%20split%20human%20face%2C%20dark%20moody%20palette%20of%20deep%20teal%20and%20crimson%2C%20scattered%20puzzle%20pieces%20and%20tangled%20wires%2C%20surreal%20dreamlike%20composition%2C%20unsettling%20psychological%20atmosphere%2C%20cinematic%20anime%20illustration%20with%20strong%20shadows%20and%20cold%20highlights%2C%20gripping%20mind%20bending%20mystery%20comic%20cover%20art&width=480&height=680&seq=cover-mh-12&orientation=portrait",
    category: "悬疑推理",
    status: "连载中",
    chapters: "第 121 话",
    latest: "8 小时前更新",
    views: "7640 万",
    rating: 9.1,
    tags: ["心理", "烧脑", "都市"],
    description: "一座会吞噬记忆的城市，一段支离破碎的过去。当主角发现自己遗忘了最重要的东西，追寻真相的每一步，都让人细思极恐。",
  },
  {
    id: "13",
    title: "机甲炼成师",
    cover: "https://readdy.ai/api/search-image?query=Mecha%20engineering%20manga%20cover%20of%20a%20young%20inventor%20working%20on%20a%20half-built%20giant%20robot%20in%20a%20high-tech%20workshop%2C%20glowing%20blue%20and%20steel%20gray%20tones%20with%20warm%20red%20sparks%2C%20holographic%20blueprints%20and%20gears%20floating%20around%2C%20industrial%20mechanical%20aesthetic%2C%20detailed%20machinery%2C%20dynamic%20anime%20illustration%20with%20dramatic%20workshop%20lighting%2C%20passionate%20creation%20atmosphere%2C%20futuristic%20mecha%20building%20comic%20cover%20art&width=480&height=680&seq=cover-mh-13&orientation=portrait",
    category: "科幻冒险",
    status: "连载中",
    chapters: "第 237 话",
    latest: "前天更新",
    views: "1.02 亿",
    rating: 9.3,
    tags: ["机甲", "科幻", "热血"],
    description: "被学院放弃的差生，却有一双能看穿一切机械结构的神眼。他亲手炼成的每一台机甲，都在战场上一鸣惊人，震撼整个星盟。",
  },
  {
    id: "14",
    title: "老板今天也在摸鱼",
    cover: "https://readdy.ai/api/search-image?query=Funny%20office%20comedy%20manga%20cover%20with%20a%20scheming%20lazy%20boss%20hiding%20under%20his%20desk%20eating%20snacks%20while%20avoiding%20work%2C%20bright%20warm%20colors%20with%20orange%20and%20gold%20accents%2C%20exaggerated%20hilarious%20expressions%2C%20tiny%20sweat%20drops%20and%20motion%20lines%2C%20playful%20cartoon%20anime%20style%2C%20relatable%20workplace%20humor%2C%20light%20bold%20linework%2C%20comedic%20office%20life%20comic%20cover%20art&width=480&height=680&seq=cover-mh-14&orientation=portrait",
    category: "搞笑日常",
    status: "已完结",
    chapters: "全 132 话",
    latest: "已完结",
    views: "9350 万",
    rating: 8.9,
    tags: ["职场", "搞笑", "日常"],
    description: "表面威严实则摸鱼的沙雕老板，和一群被迫营业的打工人们，上演一出出让人爆笑又共鸣的办公室大戏，打工人必看。",
  },
  {
    id: "15",
    title: "剑下山河",
    cover: "https://readdy.ai/api/search-image?query=Epic%20wuxia%20manga%20cover%20of%20a%20lone%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20overlooking%20a%20vast%20landscape%20of%20rivers%20and%20mountains%2C%20ink%20wash%20and%20deep%20teal%20palette%20with%20crimson%20accent%2C%20sweeping%20clouds%20and%20distant%20peaks%2C%20solitary%20heroic%20silhouette%2C%20refined%20traditional%20Chinese%20art%20combined%20with%20anime%2C%20dramatic%20atmospheric%20lighting%2C%20breathtaking%20swordplay%20fantasy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-15&orientation=portrait",
    category: "武侠仙侠",
    status: "连载中",
    chapters: "第 283 话",
    latest: "5 小时前更新",
    views: "1.44 亿",
    rating: 9.6,
    tags: ["武侠", "江湖", "家国"],
    description: "乱世之下，一介布衣仗剑下山。他守一城、护一人，剑下斩尽奸邪，也守住万里山河。江湖与家国，皆在这一剑之间。",
  },
  {
    id: "16",
    title: "四季小店",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20healing%20manga%20cover%20of%20a%20small%20seasonal%20shop%20in%20a%20quiet%20lane%20during%20springtime%20with%20blooming%20trees%20and%20warm%20afternoon%20light%2C%20soft%20pastel%20palette%20of%20cream%20pink%20and%20mint%20green%2C%20a%20kind%20shopkeeper%20arranging%20flowers%2C%20peaceful%20comforting%20atmosphere%2C%20kawaii%20detailed%20anime%20illustration%2C%20tender%20warmth%20and%20serenity%2C%20cozy%20slice%20of%20life%20healing%20comic%20cover%20art&width=480&height=680&seq=cover-mh-16&orientation=portrait",
    category: "治愈温馨",
    status: "连载中",
    chapters: "第 96 话",
    latest: "2 天前更新",
    views: "6880 万",
    rating: 9.3,
    tags: ["治愈", "日常", "慢生活"],
    description: "巷尾的四季小店，只在每个季节更替时开张。店主用当季的食材与心意，招待每一位有故事的路人，温柔治愈每一段人生。",
  },
  {
    id: "17",
    title: "吞噬万界",
    cover: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20of%20a%20powerful%20warrior%20absorbing%20swirling%20cosmic%20energy%20with%20a%20vortex%20of%20worlds%20collapsing%20behind%20him%2C%20deep%20crimson%20and%20black%20palette%20with%20glowing%20gold%20veins%2C%20menacing%20but%20imposing%20aura%2C%20epic%20destruction%20and%20power%20atmosphere%2C%20bold%20anime%20illustration%2C%20dramatic%20high%20contrast%20lighting%2C%20intense%20cultivation%20power%20fantasy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-17&orientation=portrait",
    category: "热血玄幻",
    status: "连载中",
    chapters: "第 201 话",
    latest: "7 小时前更新",
    views: "1.76 亿",
    rating: 9.1,
    tags: ["玄幻", "吞噬", "热血"],
    description: "身怀吞噬之体的少年，能吞天地灵气、吞万物神源。当所有人都视他为灾厄，他却要用这股力量，吞出一个崭新的时代。",
  },
  {
    id: "18",
    title: "时光咖啡屋",
    cover: "https://readdy.ai/api/search-image?query=Magical%20cozy%20manga%20cover%20of%20a%20warm%20coffee%20shop%20with%20glowing%20lanterns%20and%20a%20mysterious%20clock%20on%20the%20wall%2C%20steam%20rising%20from%20cups%2C%20rich%20brown%20cream%20and%20golden%20amber%20tones%2C%20a%20barista%20with%20a%20gentle%20smile%20pouring%20coffee%2C%20nostalgic%20heartwarming%20atmosphere%2C%20detailed%20anime%20illustration%20with%20soft%20magical%20glow%2C%20comforting%20time-travel%20romance%20feel%2C%20enchanting%20cozy%20fantasy%20comic%20cover%20art&width=480&height=680&seq=cover-mh-18&orientation=portrait",
    category: "治愈温馨",
    status: "连载中",
    chapters: "第 87 话",
    latest: "1 天前更新",
    views: "7210 万",
    rating: 9.2,
    tags: ["治愈", "奇幻", "时光"],
    description: "这家咖啡屋的钟，会带你去往回忆里的那一天。有人说它是逃避，可店主只说，勇敢告别的人，才配再次启程。",
  },
];

export default comics;